<template>
  <div style="margin-left: 5px;">
    <div style="margin-top: 5px;" class="form-group">
      <label>Ragione sociale</label>
      <br>
      <input class="jqx-input-material" ref="ragione_sociale" id="pac-input2" type="text"
             placeholder="" style="margin-top: 10px; width:100%;" autocomplete="randomText" @focus="setAutocomplete()" >
    </div>
    <div class="form-group">
      <label>Indirizzo</label>
      <br>
      <JqxInput :theme="'material'" name="indirizzo" ref="indirizzo" autocomplete="randomText"></JqxInput>
    </div>

    <div class="form-group">
      <label>Stato</label>
      <br>
      <JqxInput :popupZIndex="10000" :theme="'material'" name="stato" ref="stato"
                :width="200" :height="25" :source="statoAdapter"
                :valueMember="'nome'" :displayMember="'nome'" @close="onClose($event)"
                :minLength="1" :placeHolder="'Inserire lo stato'" autocomplete="randomText">
      </JqxInput>
    </div>
    <div class="form-group">
      <label>Località</label>
      <br>
      <JqxInput :popupZIndex="10000" :theme="'material'" name="localita" ref="localita"
                :width="200" :height="25" :source="localitaAdapter"
                :valueMember="'name'" :displayMember="'display_value'" @select="localitaOnSelect($event)" :minLength="2"
                @input="updateText" :disabled="true" :placeHolder="'Inserire prima lo stato'" autocomplete="randomText">
      </JqxInput>
    </div>
    <div class="form-group">
      <label>Cap</label>
      <br>
      <JqxInput :theme="'material'" name="cap" ref="cap"
                :width="200" :height="25" :source="localitaAdapter"
                :valueMember="'name'" :displayMember="'name'" :disabled="true" autocomplete="randomText">
      </JqxInput>
    </div>
    <div class="form-group">
      <label>Provincia</label>
      <br>
      <JqxInput :theme="'material'" name="provincia" ref="provincia"
                :width="200" :height="25" :source="localitaAdapter"
                :valueMember="'name'" :displayMember="'name'" :disabled="true" autocomplete="randomText">
      </JqxInput>
    </div>
    <!--    <StatoInput ref="autoinput"></StatoInput>-->

  </div>
</template>

<script>
    import JqxInput from "~jqx/jqwidgets-vue/vue_jqxinput.vue";
    import StatoInput from ".././cruddetails/StatoInput";
    import Card from "../Card";

    let copy;
    //let selectorbyname = ["indirizzo", "stato", "localita", "provincia", "cap"];
    //const axios = require('axios');
    export default {
        name: "PlaceAutoGoogleWithoutMaps",
        data: function () {
            return {
                statoAdapter: new jqx.dataAdapter(this.statoSource),
                localitaAdapter: new jqx.dataAdapter(this.localitaSource)
            }
        },
        components: {
            Card,
            JqxInput,
            StatoInput
        },
        beforeCreate: function () {
            this.statoSource = {
                datatype: 'json',
                datafields: [
                    {name: 'nome'},
                    {name: 'nome'},
                ],
                url: '/api/cruds/read?t=' + 'AnagraficaStati',
            };
            this.localitaSource = {
                dataType: 'json',
                dataFields: [
                    {name: 'name'},
                    {name: 'postal_code'},
                    {name: 'display_value'},
                ],
                //url: '/api/cruds/read?t=' + 'PostalCodes&q=Italia-Tori',
            };
        },
        methods: {
            setAutocomplete(){
                //console.log('Sono in on focus');
                document.getElementById("pac-input2").setAttribute("autocomplete", "randomString");
            },
            initMap() {
                let cap;
                let tmplocaddress;
                let localita;
                let indirizzo;
                let stato;
                let provincia;
                let r = /\d+/;
                let rprov = /[A-Z]+$/;
                let position;
                var autocomplete = new google.maps.places.Autocomplete(document.getElementById("pac-input2"), {types: ['establishment']});
                google.maps.event.addListener(autocomplete, 'place_changed', function () {

                    let thisplace = autocomplete.getPlace();
                    if (thisplace.geometry != null) {
                        let tmpaddress = thisplace.formatted_address.split(',');
                        if (tmpaddress.length > 3) {
                            position = 2;
                            indirizzo = tmpaddress[0] + " " + tmpaddress[1];
                        } else if (tmpaddress.length <= 3) {
                            position = 1;
                            indirizzo = tmpaddress[0];
                        }
                        cap = r.exec(tmpaddress[position]);
                        tmplocaddress = tmpaddress[position].split(' ');
                        if (tmplocaddress.length == 4) {
                            if (tmplocaddress[0] == "")
                                localita = tmplocaddress[2];
                            else
                                localita = tmplocaddress[1];
                        }
                        if (tmplocaddress.length == 5) {
                            if (tmplocaddress[0] == "")
                                localita = tmplocaddress[2] + " " + tmplocaddress[3];
                            else
                                localita = tmplocaddress[1] + " " + tmplocaddress[2];
                        } else if (tmplocaddress.length == 6) {
                            if (tmplocaddress[0] == "")
                                localita = tmplocaddress[2] + " " + tmplocaddress[3] + " " + tmplocaddress[4];
                            else
                                localita = tmplocaddress[1] + " " + tmplocaddress[2] + " " + tmplocaddress[3];
                        } else if (tmplocaddress.length == 7) {
                            if (tmplocaddress[0] == "")
                                localita = tmplocaddress[2] + " " + tmplocaddress[3] + " " + tmplocaddress[4] + " " + tmplocaddress[5];
                            else
                                localita = tmplocaddress[1] + " " + tmplocaddress[2] + " " + tmplocaddress[3] + " " + tmplocaddress[4];
                        }
                        let c = tmpaddress.length - 1;
                        stato = tmpaddress[c];
                        provincia = rprov.exec(tmpaddress[c - 1]);
                        copy.$refs.indirizzo.val(indirizzo.trim());
                        copy.$refs.stato.val((stato !== "") ? stato.trim() : stato);
                        copy.$refs.localita.val((localita !== "") ? localita.trim() : stato);
                        copy.$refs.cap.val(`${cap[0]}`);
                        copy.$refs.provincia.val(`${provincia[0]}`);
                        //let compose = copy.$refs.ragione_sociale.value.split(',')[0];
                        copy.$refs.ragione_sociale.value = copy.$refs.ragione_sociale.value.split(',')[0];
                        /*document.getElementsByName("indirizzo")[0].value = indirizzo;
                        document.getElementsByName("stato")[0].value = stato;
                        document.getElementsByName("localita")[0].value = localita;
                        document.getElementsByName("cap")[0].value = cap;
                        document.getElementsByName("provincia")[0].value = provincia;*/
                        ////console.log(compose);
                        //document.getElementById("pac-input2").value = document.getElementById("pac-input2").value.split(',')[0];
                    } else {
                    }
                });
            },
            localitaOnSelect: function (event) {
                if (typeof this.$refs.localita.val() === "string")
                    return false;
                let char = this.$refs.localita.val().label.split('-');
                this.$refs.localita.value = char[0];
                this.$refs.provincia.value = char[2];
                this.$refs.cap.value = char[1];
            }, updateText: function (event) {
                let stato = this.$refs.stato.val();
                let char = this.$refs.localita.val();
                if (typeof char === 'object')
                    char = document.getElementsByName("localita")[0].value;
                if (char.length == 3) {
                    let update = {
                        dataType: 'json',
                        dataFields: [
                            {name: 'name'},
                            {name: 'postal_code'},
                            {name: 'display_value'},
                        ],
                        url: '/api/cruds/read?t=' + 'AnagraficaLocalita&q=' + stato.value + '-' + char,
                    };
                    this.$refs.localita.source = new jqx.dataAdapter(update);
                }
            },
            onClose: function (event) {
                this.$refs.localita.disabled = false;
            }
        },
        mounted: function () {
            copy = this;
            this.initMap();
        }
    }
</script>

<style scoped>

  .jqx-popup {
    position: absolute;
    cursor: default;
    z-index: 10000 !important
  }

</style>
